import { Pipe, PipeTransform } from '@angular/core';
import { Section } from '../modules/checklist/types/ChecklistTypes';

@Pipe({
  standalone: true,
  name: 'sectionItemOrder',
})
export class SectionItemOrderPipe implements PipeTransform {
  transform(value: Section[], order: 'asc' | 'desc' = 'asc'): Section[] {
    return [...value].sort((a, b) => {
      if (order === 'asc') {
        return a.position - b.position;
      } else if (order === 'desc') {
        return b.position - a.position;
      }
      return 0;
    });
  }
}
